import { Input as AntdInput } from "antd";
import classNames from "classnames";
import { noop } from "lodash";
import React, { useEffect, useRef } from "react";

import SVGIcon from "../Images/SVGIcon";
import Spin from "../Spin";
import Tooltip from "../Tooltip";
import styles from "./style.module.css";

const Input = ({
  label,
  error,
  required,
  className,
  labelClassName,
  tailIcon,
  inputClassName,
  errorClassName,
  tagContainer,
  inputWrapperClassName,
  onTailIconClick,
  tailIconClassName,
  disabled = false,
  type = "text",
  focused,
  showTailLoader = false,
  loaderClassName = null,
  dataTestId,
  tailText,
  tailTextClassName,
  isTooltipVisible = false,
  hasErrorIcon = false,
  ...props
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && focused) {
      inputRef.current.focus({
        cursor: "end",
      });
    }
  }, [focused]);

  return (
    <div className={classNames(styles.wrapper, className)}>
      {label && (
        <label
          className={classNames(styles.label, labelClassName, {
            [styles.labelRequired]: required,
          })}
        >
          {label}
        </label>
      )}
      <div className={classNames(styles.inputWrapper, inputWrapperClassName)}>
        <div className={styles.inputContainer}>
          {!!tagContainer && tagContainer}
          <Tooltip title={isTooltipVisible ? props.value : ""} placement="topLeft">
            <AntdInput
              className={classNames(styles.input, inputClassName, {
                [styles.tagInput]: !!tagContainer,
              })}
              data-testid={dataTestId || `InputField-${label}`}
              disabled={disabled}
              ref={inputRef}
              type={type}
              {...props}
            />
          </Tooltip>
        </div>

        {tailIcon ? (
          <SVGIcon
            className={classNames(styles.tailIcon, tailIconClassName, {
              [styles.disabledTailIcon]: disabled,
            })}
            src={tailIcon}
            onClick={!disabled ? onTailIconClick : noop}
          />
        ) : null}
        {showTailLoader ? <Spin className={classNames(styles.loader, loaderClassName)} /> : null}
        {tailText ? <div className={classNames(styles.tailText, tailTextClassName)}>{tailText}</div> : null}
      </div>

      {error && (
        <div data-testid={`${error}-error`} className={classNames(styles.error, errorClassName)}>
          {hasErrorIcon ? (
            <SVGIcon name="close" src="components/v2/red-info-icon.svg" className={styles.errorIcon} />
          ) : null}
          {error}
        </div>
      )}
    </div>
  );
};

export default Input;
